module.exports = __webpack_public_path__ + "assets/img/back.76f43e37.png";